module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login__content"
  }, [_c('h1', {
    staticClass: "logo logo--login",
    style: ({
      'background-image': 'url(\'brand/rose-logo.png\')'
    })
  }, [_c('span', {
    staticClass: "logo__text"
  }, [_vm._v("Rose & Associates")])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "login__form",
    attrs: {
      "method": "post",
      "action": "/",
      "name": "loginform"
    }
  }, [_c('div', {
    staticClass: "text-wrap"
  }, [_c('label', {
    staticClass: "label input__label",
    attrs: {
      "for": "login_input_username"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    staticClass: "input input--text",
    attrs: {
      "id": "login_input_username",
      "type": "text",
      "name": "user_name",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-wrap"
  }, [_c('label', {
    staticClass: "label input__label",
    attrs: {
      "for": "login_input_password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    staticClass: "input input--text",
    attrs: {
      "id": "login_input_password",
      "type": "password",
      "name": "user_password",
      "autocomplete": "off",
      "required": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "name": "login",
      "value": "Log in"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e3ae546!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 321
// module chunks = 0